@if (field.props.label) {
  <h6>{{ field.props.label | translate }}</h6>
}

<div class="repeat" [style.max-height]="field.props.maxHeight">
  @for (fi of field.fieldGroup; track $index; let i = $index) {
    <div class="row">
      <formly-field [field]="fi" class="col"></formly-field>
      <div class="col-sm-1 d-flex align-items-center">
        <button mat-icon-button type="button" (click)="remove(i)" tabindex="-1">
          <mat-icon>delete_forever</mat-icon>
        </button>
      </div>
    </div>
  }
</div>

@if (field.props.allowAdd !== false) {
  <div class="add-answer">
    <button mat-stroked-button (click)="add(undefined, this.props.newItemInitialValue ? this.props.newItemInitialValue(field) : undefined)">
      <mat-icon>add</mat-icon>
      {{ field.props.addLabel | translate }}
    </button>
  </div>
}
